import { useMapStageStore } from '@forwardflow/store/modal'
import { Modal } from 'antd'

import { ModalHead } from './ModalHead'
import { StageMapGroup } from '@forwardflow/modules/onboarding/steps/stage-mapping/StageMapGroup'
import {
   useGetFubStages,
   useGetPeopleTags,
} from '@forwardflow/queries/onboarding.queries'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { useEffect } from 'react'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { Select } from '@forwardflow/ui-v2'

export const MapStageModal = () => {
   const { isMapStageModalOpen, closeMapStageModal } = useMapStageStore()
   const { setStages, setTags, setTempStageGroupByGroupId, onboardingData } =
      useOnboardingStoreV2()

   const { tempStageGroups } = onboardingData
   const currentOrganization = LocalStorage.get('currentOrganization')
   const { data: fubStages } = useGetFubStages(
      currentOrganization,
      10000,
      1,
      true
   )

   const { data: peopleTags } = useGetPeopleTags(
      currentOrganization,
      10000,
      1,
      true
   )

   const appointMentScheduledGroup = tempStageGroups?.find(
      (group) => group.groupId === 'ff-appointment-set'
   )
   const appointMentScheduledType = appointMentScheduledGroup?.type
   const appointMentScheduledStages = appointMentScheduledGroup?.stageOrTags

   const appointMentMissedGroup = tempStageGroups?.find(
      (group) => group.groupId === 'ff-appointment-missed'
   )
   const appointMentMissedType = appointMentMissedGroup?.type
   const appointMentMissedStages = appointMentMissedGroup?.stageOrTags

   useEffect(() => {
      if (fubStages) {
         setStages(
            (fubStages?.data || [])?.map((item: any) => ({
               id: item?.stageId,
               name: item?.stageName,
               description: '',
            })) || []
         )
      }
   }, [fubStages, setStages])

   useEffect(() => {
      if (peopleTags) {
         setTags(peopleTags?.data?.map((item) => item?.tagName || '') || [])
      }
   }, [peopleTags, setTags])

   // const onFinish = () => {
   //    if (!form) return

   //    form
   //       .validateFields()
   //       .then(() => {
   //          const formValues = form.getFieldsValue()
   //          try {
   //             StageMappingService.updateStageMapping(formValues)
   //          } catch (error) {
   //             console.error('Error updating stage mapping:', error)
   //          } finally {
   //             mutate()
   //             closeMapStageModal()
   //          }
   //       })
   //       .catch((error) => {
   //          console.error('Form validation failed:', error)
   //       })
   // }

   return (
      <>
         <Modal
            zIndex={100}
            centered
            className={`p-0 ff-modal my-5 !w-[1100px]`}
            open={isMapStageModalOpen}
            onCancel={closeMapStageModal}
            title=""
            footer={null}
         >
            <ModalHead />
            <div className="p-6">
               <div className="p-6">
                  <StageMapGroup
                     hasBorder={false}
                     title="Nurture Stages"
                     groupId="ff-nurturing"
                     shouldAddDescription
                     allowAddStage
                  />
               </div>
               <hr className="border-white/10" />
               <div className="p-6 space-y-6">
                  <p className="text-white font-medium mb-4">
                     Appointment Scheduled
                  </p>
                  <Select
                     label="Type"
                     value={appointMentScheduledType}
                     onChange={(value) =>
                        setTempStageGroupByGroupId('ff-appointment-set', {
                           groupId: 'ff-appointment-set',
                           parentGroupId: null,
                           stageOrTags: appointMentScheduledStages || [],
                           type: value as 'appointment-field' | 'stage',
                        })
                     }
                     data={[
                        {
                           label: 'Appointment field in FUB',
                           value: 'appointment-field',
                        },
                        {
                           label: 'Stage',
                           value: 'stage',
                        },
                     ]}
                     description={
                        appointMentScheduledType === 'appointment-field'
                           ? 'We will understand whether a lead has appointment scheduled or not by looking at the appointment field in Follow Up Boss'
                           : ''
                     }
                  />

                  {appointMentScheduledType === 'stage' && (
                     <StageMapGroup
                        hasBorder={false}
                        groupId="ff-appointment-set"
                     />
                  )}
               </div>
               <hr className="border-white/10" />
               <div className="p-6 space-y-6">
                  <p className="text-white font-medium mb-4">
                     Appointment Missed
                  </p>
                  <Select
                     label="Type"
                     value={appointMentMissedType}
                     onChange={(value) =>
                        setTempStageGroupByGroupId('ff-appointment-missed', {
                           groupId: 'ff-appointment-missed',
                           parentGroupId: null,
                           stageOrTags: appointMentMissedStages || [],
                           type: value as 'no-criteria' | 'stage',
                        })
                     }
                     data={[
                        {
                           label: 'No criteria',
                           value: 'no-criteria',
                        },
                        {
                           label: 'Stage',
                           value: 'stage',
                        },
                     ]}
                  />
                  {appointMentMissedType === 'stage' && (
                     <StageMapGroup
                        transitionDelay={0.6}
                        hasBorder={false}
                        groupId="ff-appointment-missed"
                     />
                  )}
               </div>
               <hr className="border-white/10" />
               <div className="p-6 space-y-6">
                  <StageMapGroup
                     hasBorder={false}
                     title="Active Client Stages"
                     description="When you start working with a client, Forward Flow should stop trying to set new appointments. Select the stage or tag that represents an active or in-progress client"
                     groupId="ff-active-client"
                     shouldAddDescription
                     allowAddStage
                  />

                  <StageMapGroup
                     hasBorder={false}
                     title="Under Contract"
                     groupId="ff-under-contract"
                  />

                  <StageMapGroup
                     hasBorder={false}
                     title="Do Not Contact"
                     groupId="ff-do-not-contact"
                  />

                  <StageMapGroup
                     hasBorder={false}
                     title="Has an Agent"
                     isOptional
                     groupId="ff-has-agent"
                  />

                  <StageMapGroup
                     hasBorder={false}
                     title="Closed"
                     isOptional
                     groupId="ff-closed-client"
                  />

                  <StageMapGroup
                     hasBorder={false}
                     title="Other Stop Criteria"
                     description="Add any other stop stages you have where we should stop contacting your leads"
                     groupId="ff-other-stop"
                     allowAddStage
                     shouldAddDescription
                  />
               </div>
            </div>
         </Modal>
      </>
   )
}
